'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _businesses = require('./businesses.component');

var _businesses2 = _interopRequireDefault(_businesses);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var businessesModule = _angular2.default.module('app.containers.businesses', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('businesses', {
    url: '/businesses',
    template: '<businesses></businesses>'
  });
}).component('businesses', _businesses2.default);

exports.default = businessesModule;


/** WEBPACK FOOTER **
 ** ./client/app/containers/businesses/businesses.js
 **/